module.exports = "https://r.zoocdn.com/_next/static/images/help-to-buy-5f6a075e22fcad044ccf93648bff245a.png";